import React from 'react';

const SvgBz = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="BZ_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="BZ_svg__b" fill="#fff">
        <use xlinkHref="#BZ_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#BZ_svg__a" />
      <path fill="#094995" mask="url(#BZ_svg__b)" d="M0 2.667h28v14.667H0z" />
      <path
        fill="#D5182F"
        mask="url(#BZ_svg__b)"
        d="M0 0h28v2.667H0zM0 17.333h28V20H0z"
      />
      <circle fill="#FFF" mask="url(#BZ_svg__b)" cx={14} cy={10} r={6} />
      <path
        d="M14 14a4 4 0 1 0 0-8 4 4 0 0 0 0 8z"
        stroke="#118014"
        strokeWidth={1.333}
        strokeLinecap="round"
        strokeDasharray="0.6666666666666666 2"
        mask="url(#BZ_svg__b)"
      />
    </g>
  </svg>
);

export default SvgBz;
